import { render, staticRenderFns } from "./videoIframe.vue?vue&type=template&id=35e6073d&"
import script from "./videoIframe.vue?vue&type=script&lang=js&"
export * from "./videoIframe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('35e6073d')) {
      api.createRecord('35e6073d', component.options)
    } else {
      api.reload('35e6073d', component.options)
    }
    module.hot.accept("./videoIframe.vue?vue&type=template&id=35e6073d&", function () {
      api.rerender('35e6073d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2B6pihqP2K7c4/JS/videoIframe.vue"
export default component.exports